import { isPositiveNumber } from "et3-type-guards";
import { memoize, orderBy } from "lodash";
import { computed, observable, runInAction } from "mobx";

import { apiCallGetUserMessageById } from "../../../api/user-api/api-call-get-user-message-by-id";
import { parseConversationData } from "../../../helpers/et3-conversation-parse";
import { TSeachedUser, TUserMessagesObject } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { TEt3PickerSingleValue } from "../../../TypesNEW";

class UserMessageIdStore {
  messageIdInput = observable.box<number>(-1);

  messageEra = observable.box<TEt3PickerSingleValue>({
    label: "POST_2025",
    value: "POST_2025"
  });

  userMessageIdData = observable.box<TUserMessagesObject[]>([]);
  searchedUser = observable.box<TSeachedUser>({
    userID: -1,
    userGender: ""
  });
  userMessageIdDataOrdered = computed(() => {
    const orderedAuditedEvents: TUserMessagesObject[] = orderBy(
      this.userMessageIdData.get(),
      ["sentOn"],
      ["desc"]
    );
    return orderedAuditedEvents;
  });
  setMessageEra = (limit: TEt3PickerSingleValue) => {
    runInAction(() => {
      this.messageEra.set(limit);
    });
  };
  getUserMessagesByMessageID = async () => {
    const messageId = this.messageIdInput.get();
    const messageEra = this.messageEra.get().value;
    if (!isPositiveNumber(messageId)) {
      getCorePopUpStore().showAlertMessage("WRONG_MESSAGE_ID");
      return;
    }
    getCoreUIStore().setIsLoading("USER_MESSAGE_ID", true);
    const { data, code, status } = await apiCallGetUserMessageById({
      messageId,
      messageEra
    });

    const parsedData = parseConversationData(data.messages);
    this.userMessageIdData.set(parsedData);
    this.searchedUser.set(data.searchedUser);
    getCoreUIStore().setIsLoading("USER_MESSAGE_ID", false);
    if (status === "ERROR") {
      this.userMessageIdData.set([]);
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getUserMessageIdStore = memoize(
  () => new UserMessageIdStore(),
  () => 1
);
export default getUserMessageIdStore;
